// extracted by mini-css-extract-plugin
export default {"brand_see_all_item":"style_brand_see_all_item__N2UBg","brands_img_item":"style_brands_img_item__NuPHB","nameof_brand_item":"style_nameof_brand_item__0fFEb"};